var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 459,
    viewBox: "0 0 564 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.229 119.236L210.615 136.887L138.351 94.9637L170.071 77.3125L241.229 119.236Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.229 212.464L210.615 230.115L138.351 188.191L170.071 170.54L241.229 212.464Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.058 212.464L210.438 230.115L138.174 188.191L169.894 170.54L241.058 212.464Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.615 136.887V230.115",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.346 77.3125V170.541L138.378 188.16V94.9369",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23 118.931V212.159",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.748 171.642L115.128 189.294L42.8643 147.37L74.5849 129.719L145.748 171.642Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.748 264.87L115.128 282.521L42.8643 240.597L74.5849 222.946L145.748 264.87Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.571 264.87L114.957 282.521L42.6924 240.597L74.413 222.946L145.571 264.87Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.129 189.294V282.523",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8588 129.719V222.947L42.8965 240.566V147.343",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.749 171.336V264.565",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.436 165.853L405.822 183.504L333.558 141.58L365.278 123.924L436.436 165.853Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.436 259.076L405.822 276.733L333.558 234.804L365.278 217.152L436.436 259.076Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.265 259.076L405.65 276.733L333.381 234.804L365.101 217.152L436.265 259.076Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.822 183.505V276.734",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.553 123.924V217.153L333.591 234.777V141.548",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.438 165.546V258.769",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.307 218.452L500.693 236.104L428.429 194.18L460.144 176.523L531.307 218.452Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.307 311.675L500.693 329.331L428.429 287.402L460.144 269.751L531.307 311.675Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.136 311.675L500.516 329.331L428.252 287.402L459.973 269.751L531.136 311.675Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.693 236.104V329.333",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.424 176.523V269.752L428.456 287.377V194.148",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.308 218.146V311.369",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.124 102.799L296.738 120.45L369.003 78.5262L337.287 60.875L266.124 102.799Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.124 196.026L296.738 213.677L369.003 171.754L337.287 154.103L266.124 196.026Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.296 196.026L296.916 213.677L369.18 171.754L337.459 154.103L266.296 196.026Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.738 120.45V213.679",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.008 60.875V154.104L368.975 171.723V78.494",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.124 102.492V195.721",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.747 60.7938L229.361 78.445L301.626 36.5213L269.91 18.8701L198.747 60.7938Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.747 154.023L229.361 171.674L301.626 129.75L269.91 112.094L198.747 154.023Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.919 154.023L229.539 171.674L301.803 129.75L270.082 112.094L198.919 154.023Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.361 78.4453V171.674",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.631 18.8701V112.093L301.599 129.718V36.4891",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.747 60.4873V153.716",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.723 347.15L301.342 364.801L373.607 322.877L341.886 305.221L270.723 347.15Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.723 440.372L301.342 458.028L373.607 416.099L341.886 398.448L270.723 440.372Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.899 440.372L301.514 458.028L373.778 416.099L342.063 398.448L270.899 440.372Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.342 364.801V458.029",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.612 305.221V398.449L373.575 416.074V322.845",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.723 346.843V440.066",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.616 305.335L241.231 322.991L313.495 281.062L281.78 263.411L210.616 305.335Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.616 398.562L241.231 416.214L313.495 374.29L281.78 356.639L210.616 398.562Z",
    stroke: "#231F20",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.788 398.562L241.408 416.214L313.672 374.29L281.951 356.639L210.788 398.562Z",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23 322.992V416.215",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 263.411V356.64L313.468 374.259V281.035",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.616 305.028V398.257",
    stroke: "white",
    strokeWidth: 1.2888,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.227 115.246L549.2 377.92",
    stroke: "white",
    strokeWidth: 10.3265,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.185 346.918L388.891 403.013L159.232 269.778L260.033 213.678L486.185 346.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.835 326.436L167.641 270.336",
    stroke: "white",
    strokeWidth: 10.3265,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.377 250.715C233.949 250.307 232.875 250.006 231.699 249.673C233.906 246.081 236.043 242.59 238.272 238.965C237.133 238.681 236.193 238.444 235.098 238.165C237.16 234.331 239.179 230.577 241.284 226.652C240.001 226.464 238.938 226.308 237.504 226.099C242.074 219.649 244.721 212.437 247.476 204.839C250.343 212.352 252.846 219.633 257.545 226.093C256.105 226.297 255.015 226.453 253.7 226.641C255.805 230.529 257.818 234.256 259.923 238.149C258.887 238.412 257.953 238.648 256.718 238.96C258.935 242.563 261.094 246.075 263.317 249.684C262.104 250.022 261.03 250.317 259.628 250.709C262.437 254.71 265.138 258.555 268.091 262.771H250.408V276.684H244.651V262.873H226.85C229.83 258.625 232.531 254.775 235.377 250.715Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.253 285.802C353.287 285.528 352.562 285.324 351.767 285.098C353.26 282.666 354.704 280.314 356.208 277.86C355.44 277.666 354.801 277.505 354.06 277.323C355.451 274.729 356.82 272.189 358.243 269.536C357.373 269.407 356.659 269.305 355.687 269.16C358.775 264.8 360.568 259.924 362.426 254.79C364.365 259.87 366.057 264.789 369.236 269.16C368.264 269.3 367.523 269.402 366.636 269.531C368.06 272.162 369.418 274.681 370.841 277.312C370.138 277.489 369.509 277.65 368.677 277.86C370.175 280.298 371.636 282.671 373.14 285.109C372.318 285.335 371.593 285.539 370.648 285.802C372.549 288.508 374.369 291.107 376.372 293.953H364.419V303.362H360.525V294.023H348.491C350.505 291.15 352.331 288.546 354.259 285.802H354.253Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M401.864 353.571C400.897 353.297 400.172 353.093 399.377 352.868C400.87 350.435 402.315 348.083 403.818 345.629C403.05 345.436 402.411 345.275 401.67 345.092C403.061 342.498 404.43 339.958 405.854 337.306C404.984 337.177 404.269 337.075 403.297 336.93C406.385 332.569 408.179 327.693 410.037 322.56C411.975 327.64 413.667 332.559 416.846 336.93C415.874 337.069 415.133 337.171 414.247 337.3C415.67 339.932 417.028 342.45 418.452 345.081C417.748 345.259 417.12 345.42 416.287 345.629C417.786 348.067 419.246 350.441 420.75 352.879C419.928 353.104 419.203 353.308 418.258 353.571C420.159 356.278 421.98 358.877 423.983 361.723H412.029V371.131H408.136V361.793H396.102C398.115 358.92 399.941 356.315 401.869 353.571H401.864Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.671 259.28C213.044 258.818 211.825 258.474 210.488 258.093C213.001 254.001 215.433 250.033 217.968 245.903C216.674 245.576 215.605 245.307 214.354 244.996C216.701 240.63 218.999 236.355 221.4 231.888C219.939 231.673 218.731 231.496 217.093 231.254C222.291 223.908 225.314 215.697 228.445 207.046C231.71 215.6 234.561 223.892 239.91 231.249C238.272 231.479 237.026 231.657 235.533 231.871C237.928 236.302 240.221 240.544 242.616 244.974C241.435 245.275 240.372 245.543 238.965 245.898C241.489 250.001 243.948 253.996 246.477 258.109C245.097 258.491 243.873 258.834 242.278 259.275C245.473 263.834 248.55 268.21 251.917 273.006H231.78V288.847H225.223V273.118H204.951C208.345 268.28 211.422 263.893 214.666 259.275L214.671 259.28Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.18 264.258C323.553 263.797 322.334 263.453 320.996 263.072C323.51 258.98 325.942 255.011 328.477 250.882C327.183 250.554 326.114 250.286 324.863 249.974C327.21 245.608 329.508 241.334 331.908 236.866C330.448 236.651 329.239 236.474 327.602 236.232C332.8 228.886 335.823 220.675 338.954 212.024C342.219 220.579 345.07 228.87 350.419 236.227C348.781 236.458 347.535 236.635 346.042 236.85C348.437 241.28 350.73 245.523 353.125 249.953C351.944 250.253 350.881 250.522 349.474 250.876C351.998 254.979 354.457 258.974 356.986 263.088C355.606 263.469 354.382 263.813 352.787 264.253C355.982 268.812 359.059 273.189 362.426 277.984H342.289V293.826H335.732V278.097H315.46C318.854 273.259 321.931 268.871 325.174 264.253L325.18 264.258Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376.35 367.968C374.723 367.507 373.503 367.163 372.166 366.782C374.68 362.69 377.112 358.721 379.647 354.592C378.353 354.264 377.284 353.996 376.033 353.684C378.379 349.318 380.678 345.044 383.078 340.576C381.618 340.361 380.409 340.184 378.771 339.942C383.97 332.596 386.993 324.385 390.124 315.734C393.389 324.289 396.24 332.58 401.589 339.937C399.951 340.168 398.705 340.345 397.212 340.56C399.607 344.99 401.9 349.232 404.295 353.663C403.114 353.963 402.05 354.232 400.644 354.586C403.167 358.689 405.627 362.684 408.156 366.798C406.776 367.179 405.552 367.523 403.957 367.963C407.152 372.522 410.229 376.899 413.596 381.694H393.458V397.536H386.902V381.807H366.63C370.024 376.969 373.101 372.581 376.344 367.963L376.35 367.968Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.58297,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.254 81.9366L171.109 7.40625L8 108.636L186.408 212.745",
    stroke: "#F69320",
    strokeWidth: 7.74355,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.773 146.403L555 239.75L390.012 321.933L381.039 326.728L290.098 273.656",
    stroke: "#F69320",
    strokeWidth: 7.74355,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.525 87.8211C257.776 87.8211 277.435 68.1617 277.435 43.9105C277.435 19.6594 257.776 0 233.525 0C209.274 0 189.614 19.6594 189.614 43.9105C189.614 68.1617 209.274 87.8211 233.525 87.8211Z",
    fill: "#F69320"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M400.934 173.113L400.526 145.662L428.456 143.567",
    stroke: "#F69320",
    strokeWidth: 7.74355,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.438 189.078L191.326 215.375L165.029 225.014",
    stroke: "#F69320",
    strokeWidth: 7.74355,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.50132b74bd37c697478e7001da94f9ab.svg";
export { ForwardRef as ReactComponent };